import { ControllingFilters } from '@myapp/contract'
import { useQuery } from '@tanstack/react-query'
import { controllingApi, ControllingListResponse } from '../controllingApi'
import { controllingKeys } from '../keys'

export function useControllingQuery(filters: ControllingFilters & { page: number }) {
  return useQuery<ControllingListResponse>({
    queryKey: controllingKeys.list(filters),
    queryFn: () => controllingApi.search(filters).then((r) => r.data),
    placeholderData: (prev) => prev,
  })
}
